<template>
  <div class="width-a main-info">
    <ul class="module-a">
      <li>消息中心</li>
      <li :class="msgType == 0? 'msgtype-selected' : ''" @click="msgTypeTap(0)">通知</li>
      <li :class="msgType == 1? 'msgtype-selected' : ''" @click="msgTypeTap(1)">私信</li>
    </ul>
    <div class="module-b">
      <div v-show="msgType == 0" class="m-nav">
        <ul class="left">
          <li v-bind:class="navIndex == 0 ? 'selected' : 'normal'" v-on:click="navTap(0)">全部通知</li>
          <li v-bind:class="navIndex == 1 ? 'selected' : 'normal'" v-on:click="navTap(1)">公告</li>
          <li v-bind:class="navIndex == 2 ? 'selected' : 'normal'" v-on:click="navTap(2)">系统</li>
        </ul>
        <div class="right" v-show="userRole === 'admin'" @click="handleAddNotice">发布通知</div>
      </div>
      <div v-show="msgType == 1" class="m-nav">
        <ul class="left">
          <li v-bind:class="navIndex == 3 ? 'selected' : 'normal'" v-on:click="navTap(3)">私信箱</li>
          <li v-bind:class="navIndex == 4 ? 'selected' : 'normal'" v-on:click="navTap(4)">已发送</li>
          <li v-bind:class="navIndex == 5 ? 'selected' : 'normal'" v-on:click="navTap(5)">发私信</li>
        </ul>
      </div>
      <!-- 通知 -->
      <div v-show="msgType == 0" class="m-message">
        <template v-for="(item, index) in noticeList">
          <div class="message" v-bind:key="index">
            <img class="avator" src="@/assets/avator01.png" alt="">
            <ul class="right">
              <li class="notice-name">
                <span style="color: #3d6fd8">公告</span>
                <div>
                  <span class="notice-tool" v-show="userRole === 'admin'" @click="handleEditNotice(item)">编辑</span>
                  <span class="notice-tool" v-show="userRole === 'admin'"
                    @click="handleDeleteNotice(item.noticeId)">删除</span>
                </div>
              </li>
              <li class="content">
                <h4>标题: {{item.noticeTitle}}</h4>
                <p style="margin: 6px 0px 6px">时间: {{item.publishTime}}</p>
                <div>内容: </div>
                <div style="text-indent: 3em" v-html="item.noticeContent"></div>
              </li>
            </ul>
          </div>
        </template>
      </div>
      <!--私信箱(我收到的信息)-->
      <div v-if="msgType == 1 && navIndex == 3" class="m-message">
        <template v-for="(item, index) in messageListB">
          <div class="message" v-bind:key="index" v-if="item.sendUser">
            <img class="avator" src="@/assets/avator01.png" alt="">
            <ul class="middle">
              <li class="name" v-if="item.sendUser">{{item.sendUser.nickName}}</li>
              <li class="content">{{item.sendContent}}</li>
            </ul>
            <div class="btn" @click="replyTap(item)">回复</div>
          </div>
        </template>
      </div>
      <!--已发送(我发送的记录)-->
      <div v-if="msgType == 1 && navIndex == 4" class="m-message">
        <template v-for="(item, index) in messageListB">
          <div class="message" v-bind:key="index">
            <img class="avator" src="@/assets/avator01.png" alt="">
            <ul class="middle">
              <li class="name" v-if="item.sendUser">{{item.sendUser.nickName}}</li>
              <li class="content">{{item.sendContent}}</li>
            </ul>
          </div>
        </template>
      </div>
      <!--发私信-->
      <contacts v-show="msgType == 1 && navIndex == 5"></contacts>
    </div>
    <el-dialog title="回复" :visible.sync="dialogVisibleReply" :close-on-click-modal="false">
      <el-form ref="formReply" :model="formReply" label-width="100px">
        <el-form-item label="收信人" prop="receiveUserId">
          <el-input v-model="formReply.receiveUserName" readonly clearable />
        </el-form-item>
        <el-form-item label="内容" prop="sendContent">
          <el-input type="textarea" v-model="formReply.sendContent" rows="10" style="resize: none"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button v-on:click="resetFormReply('formReply')">取 消</el-button>
        <el-button type="primary" @click="submitFormReply('formReply')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import "multi-items-input";
  import "multi-items-input/dist/multi-items-input.css";
  import Contacts from "@/components/Contacts";
  export default {
    name: "MessageCenter",
    components: { Contacts },
    data () {
      return {
        sendUserId: "",
        noticeList: [],
        messageListB: [],
        formReply: {},
        msgType: 0,
        navIndex: 0,
        dialogVisibleReply: false
      };
    },
    computed: {
      userInfo () {
        return this.$store.state.user.userInfo;
      },
      messageList () {
        return this.$store.state.app.messageList;
      },
      userRole () {
        return this.$store.state.user.userInfo.roleKey;
      }
    },
    mounted () {
      this.msgType = this.$route.query.msgType;
      this.navIndex = this.$route.query.navIndex;
      this.getNoticeList(this);
      this.getMsgList(this)
    },
    methods: {
      /*
      * 右侧顶部导航
      * */
      navTap (index) {
        let that = this;
        that.navIndex = index;
        if (index === 0 || index === 1 || index === 2) {
          that.getNoticeList(that);
          return;
        }
        if (index === 3) {
          that.sendUserId = "";
          that.getMsgList(that);
        }
        if (index === 4) {
          that.sendUserId = that.userInfo.userId;
          that.getMsgList(that);
        }
      },
      /*
      * 左侧 通知 私信
      * */
      msgTypeTap (index) {
        this.msgType = index;
        if (index === 0) {
          this.navIndex = 0;
          this.getNoticeList(this);
        } else if (index === 1) {
          this.navIndex = 3;
          this.getMsgList(this);
        }
      },
      getNoticeList (that) {
        that.HttpConnection.get("/msg/notice/list", {
          params: {
            noticeType: this.navIndex,
            pageNum: 1,
            pageSize: 10
          }
        }).then(function (response) {
          that.noticeList = response.rows;
        });
      },
      getMsgList (that) {
        that.HttpConnection.get("/msg/letter/list", {
          params: {
            sendUserId: this.sendUserId,
            pageNum: 1,
            pageSize: 10
          }
        }).then(function (response) {
          that.messageListB = response.rows;
          console.log(that.messageListB)
        });
      },
      /*
      * 回复私信消息
      * */
      submitFormReply (formReply) {
        let that = this;
        that.HttpConnection.post("/msg/letter/save", {
          sendNoticeIs: true, // true站内信; false短信
          sendContent: that.formReply.sendContent,
          receiveUserId: that.formReply.receiveUserId
        }).then(function (response) {
          that.resetFormReply(formReply);
          that.$message({
            type: "success",
            message: "发送成功!"
          });
        });
      },
      resetFormReply (formReply) {
        this.dialogVisibleReply = false;
        this.$refs[formReply].resetFields();
        this.formReply = {};
      },
      handleDeleteNotice (id) {
        let that = this;
        that.$confirm("确定要删除该条通知吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          that.HttpConnection.delete("/msg/notice/batchRemove/" + id).then(function (response) {
            that.getNoticeList(that);
            that.$message({
              type: "success",
              message: "删除成功!"
            });
          });
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
      },
      handleAddNotice () {
        let _mNotice = {
          noticeType: 1,
          noticeTitle: "",
          noticeContent: "",
          publishTime: "",
          publishTarget: 0,
          sendNoticeIs: true
        };
        this.$router.push({
          path: "/MessageNotice",
          query: {
            mNotice: _mNotice,
            isEdit: 1
          }
        });
      },
      handleEditNotice (notice) {
        let _mNotice = {
          noticeId: notice.noticeId,
          noticeType: notice.noticeType,
          noticeTitle: notice.noticeTitle,
          noticeContent: notice.noticeContent,
          publishTime: notice.publishTime,
          publishTarget: notice.publishTarget,
          sendNoticeIs: true
        };
        this.$router.push({
          path: "/MessageNotice",
          query: {
            mNotice: _mNotice,
            isEdit: 0
          }
        });
      },
      /*
      * 点击回复
      * */
      replyTap (item) {
        this.dialogVisibleReply = true;
        this.formReply = {
          receiveUserName: item.sendUser.nickName,
          receiveUserId: item.sendUser.userId,
          sendContent: ""
        };
      }
    }
  };
</script>

<style scoped lang="scss">
  .main-info {
    display: flex;
  }

  .module-a {
    width: 220px;
    height: 600px;
    margin-right: 20px;
    padding: 20px;
    background-color: #f5f7fa;
    border-radius: 5px;
    border: 1px solid #ebedf0;

    li:nth-of-type(1) {
      display: flex;
      align-items: center;

      &::before {
        content: "";
        display: inline-block;
        background-color: #3d6fd8;
        width: 4px;
        height: 15px;
        border-radius: 2px;
        margin-right: 5px;
      }
    }

    li:nth-of-type(2) {
      cursor: pointer;
      padding: 10px 0px 0px 16px;
    }

    li:nth-of-type(3) {
      cursor: pointer;
      padding: 10px 0px 0px 16px;
    }

    .msgtype-selected {
      color: #3d6fd8;
    }
  }

  .module-b {
    width: 930px;
  }

  .m-nav {
    width: 930px;
    height: 48px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: #f5f7fa;
    border: 1px solid #ebedf0;
    border-radius: 5px;
    padding: 0px 24px;

    .left {
      display: flex;
      align-items: center;

      li {
        cursor: pointer;
        margin: 0px 20px 0px 0px;
        padding: 0px 0px 4px 0px;
      }

      .normal {
        color: #000000;
        border-bottom: 2px solid #f5f7fa;
        user-select: none;
      }

      .selected {
        color: #3d6fd8;
        border-bottom: 2px solid #3d6fd8;
        user-select: none;
      }
    }

    .right {
      cursor: pointer;
      color: #3d6fd8;
      user-select: none;
    }
  }

  .m-message {
    width: 930px;
    margin: 20px 0px 0px 0px;
    padding: 0px 10px 0px 20px;
    background-color: #f5f7fa;
  }

  .message {
    padding: 20px 0px 20px 0px;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #ebedf0;

    .middle {
      width: 770px;
      margin: 0px 14px 0px 14px;
    }

    .right {
      width: 860px;
      margin: 0px 14px 0px 14px;

      .notice-name {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 0px 0px 8px 0px;

        .notice-tool {
          color: #3d6fd8;
          margin: 0px 6px;
          cursor: pointer;
          user-select: none;
        }
      }
    }

    .avator {
      width: 40px;
      height: 40px;
    }

    .name {
      color: #3d6fd8;
      margin: 0px 0px 8px 0px;
    }

    .content {
      background-color: #e4eeff;
      padding: 6px 10px 6px 10px;
      font-size: 14px;
    }

    .btn {
      width: 60px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      background-color: #3d6fd8;
      border-radius: 12px;
      color: #ffffff;
      font-size: 14px;
      align-self: flex-end;
      cursor: pointer;
      user-select: none;
    }
  }

  /deep/ .quill-edit .ql-container.ql-snow {
    height: 250px;
  }

  /deep/::-webkit-scrollbar {
    width: 0;
  }
</style>
